import React, { forwardRef, useEffect, useRef, useState } from 'react'
import styles from './styles.module.scss'
import ConditionalRender from 'utils/conditionalRender'
import XInput, { XInputTypeEnum } from 'v2/components/XInput'
import { useOnClickOutside } from 'v2/hooks/useOnClickOutside'
import LockSvg from 'assets/svgs/locked.svg'
import { Icon } from '@material-ui/core'
import { useFormContext } from 'react-hook-form'
import { GENERIC_ERRORS } from '../../constants'
import clsx from 'clsx'
import XText from '../XText'
import { useTranslation } from 'i18n'
import XColors from 'v2/styles/colors'
import { XTEXT_ALIGNMENT, XTEXT_TYPE } from 'v2/styles/constants'

interface Props {
    dropdownData: string[]
    label: string
    placeholder?: string
    disabled?: boolean
    noMargin?: boolean
    id: string
    name: string
    defaultValue?: string
    footer?: boolean
    onChange?: (val) => void
    hasDeleteButton?: string[]
    onDelete?: (value) => void
}

const XDropdown = forwardRef<any, Props>((props: Props, ref) => {
    const { dropdownData, label, placeholder, disabled, name, id } = props
    const [isOpen, setIsOpen] = useState(false)

    const clickOutsideRef = useRef()
    const { register, setValue, clearErrors } = useFormContext()
    const { t } = useTranslation()

    useOnClickOutside(clickOutsideRef, () => {
        setIsOpen(false)
    })
    const inputValueHandler = (item) => {
        setValue(props.id, item)
        clearErrors(props.id)
    }

    useEffect(() => {
        if (props.defaultValue) {
            setValue(props.id, props.defaultValue)
        }
    }, [props.defaultValue])

    return (
        <div className={styles.xDropdown} data-infooter={props.footer} ref={clickOutsideRef}>
            <XInput
                id={id}
                name={name}
                noMargin={props.noMargin}
                type={XInputTypeEnum.DROPDOWN}
                label={label}
                onClick={() => {
                    setIsOpen(!isOpen)
                }}
                readOnly
                placeholder={placeholder}
                ref={register({ required: GENERIC_ERRORS.REQUIRED_FIELD })}
            />
            <ConditionalRender if={!disabled}>
                <Icon
                    className={styles.xDropdown__arrow}
                    onClick={() => {
                        setIsOpen(!isOpen)
                    }}
                >
                    {isOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
                </Icon>
            </ConditionalRender>
            <ConditionalRender if={disabled}>
                <LockSvg className={styles.xDropdown__lock} />
            </ConditionalRender>

            <ConditionalRender if={isOpen && !disabled}>
                <div
                    className={`${
                        props.footer
                            ? clsx(styles.transparent_container, styles.transparent_container__directionUp)
                            : styles.transparent_container
                    }`}
                >
                    {dropdownData.map((item, index) => {
                        return (
                            <div
                                key={index}
                                className={styles.transparent_container__item}
                                onClick={() => {
                                    inputValueHandler(item)
                                    setIsOpen(false)
                                    props.onChange?.(item)
                                }}
                            >
                                <span className={styles.xDropdown__value}>{item}</span>
                                <ConditionalRender if={props.hasDeleteButton?.[index]}>
                                    <XText
                                        color={XColors.red}
                                        type={XTEXT_TYPE.LABEL}
                                        alignment={XTEXT_ALIGNMENT.RIGHT}
                                        onClick={(e) => {
                                            setIsOpen(false)
                                            e.stopPropagation()
                                            props.onDelete(item)
                                        }}
                                    >
                                        {t('remove_message')}
                                    </XText>
                                </ConditionalRender>
                            </div>
                        )
                    })}
                </div>
            </ConditionalRender>
        </div>
    )
})

XDropdown.displayName = 'XDropdown'

export default XDropdown
